/* eslint-disable react/forbid-foreign-prop-types */
import PropTypes from 'prop-types';
import ContainerProps from 'admin-components/proptypes/groups/container';
import ThemeProps from 'admin-components/proptypes/groups/theme';
import PaletteProp from 'admin-components/proptypes/palette';

export const propTypes = {
  element: PropTypes.string,
  palette: PaletteProp,
  ...ContainerProps.propTypes,
  theme: PropTypes.shape({
    ...ThemeProps.propTypes
  })
};

export const propDescriptions = {
  palette: 'Background color of the container #visual',
  ...ContainerProps.propDescriptions
};

export const defaultProps = {
  element: 'div',
  ...ContainerProps.defaultProps,
  theme: ThemeProps.defaultProps
};
